/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { Badge, Button, styled, Tooltip } from "@mui/material";
import objectPath from "object-path";
import React, { useEffect, useMemo, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useHtmlClassService } from "../..";
import { WORK_FLOW_TYPE } from "../../../../app/config/cacheKey";
import {
  Cartable,
  CartableNotification,
} from "../../../../app/models/cartableModel";
import { GetCartableNotification } from "../../../../app/services/cartable.service";
import { DropdownTopbarItemToggler } from "../../../_partials/dropdowns/DropdownTopbarItemToggler";

export function QuickCartableSummaryDropDown(refreshQuickCartable: any) {
  let mainColor: any;

  const jsonFile = useSelector((state: any) => state.style);
  mainColor = jsonFile?.mainColor;
  const uiService = useHtmlClassService();
  const [cartable, setCartable] = useState<Cartable[]>();
  const [cartableTotalCount, setCartableTotalCount] = useState(0);

  const dispatch = useDispatch();
  const history = useHistory();
  const queryClient = useQueryClient();
  const handleClick = (item: any) => {
    // dispatch(cartableSet({ cartable: item.cartableName }));

    queryClient.setQueryData(WORK_FLOW_TYPE, item.cartableName);

    history.push({
      pathname: `/cartable/${item.cartableName}`,
      state: { refetchStatus: true },
      // search: "test",
    });
  };

  const CustomBadge = styled(Badge)({
    "& .MuiBadge-badge": {
      backgroundColor: `${mainColor}  !important`,
      color: "#fff",
      width: "30px !important",
      height: "30px !important",
      borderRadius: "20px !important",
    },
  });

  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);

  const getCartableNotification = useMutation(GetCartableNotification, {
    onSuccess: (data: CartableNotification) => {
      setCartable(data.cartables);
      setCartableTotalCount(data.totalCount);
    },
  });

  const MINUTE_MS = 15 * 60 * 1000;

  useEffect(() => {
    const interval = setInterval(() => {
      // getCartableNotification.mutate();
      //getCartables()
    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (
      refreshQuickCartable != undefined &&
      refreshQuickCartable.refreshQuickCartable
    ) {
      // getCartableNotification.mutate();
    }
  }, [refreshQuickCartable]);

  let { data, isLoading } = useQuery<CartableNotification>(
    "GetCartableNotification",
    (): Promise<CartableNotification> => {
      return GetCartableNotification();
    },
    {
      onSuccess: (data) => {
        setCartable(data.cartables);
        setCartableTotalCount(data.totalCount);
      },
    }
  );
  if (isLoading) {
    return <></>;
  }

  const repeatCallService = () => {
    //console.log("call Service: " + moment().format("DD-MM-YYYY hh:mm:ss"));
    getCartableNotification.mutate();
  };

  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div className={"borderLeft-TopBarIcon px-2 cartSummary"}>
          {cartableTotalCount != 0 ? (
            <Tooltip title="کارتابل" arrow>
              <Badge
                color={jsonFile?.badgeColor}
                sx={{
                  "&.MuiBadge-badge": {
                    fontWeight: "bold",
                    fontSize: "14px !important",
                    direction: "ltr",
                  },
                }}
                badgeContent={
                  cartableTotalCount > 99 ? "+99" : cartableTotalCount
                }
              >
                <WorkOutlineIcon className="Icons BorderColor " />
              </Badge>
            </Tooltip>
          ) : (
            <Tooltip title="کارتابل" arrow>
              <WorkOutlineIcon className="Icons BorderColor " />
            </Tooltip>
          )}
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="p-0 m-0 dropdown-menu-right dropd
      own-menu-anim dropdown-menu-top-unround dropdown-menu-xl divDrop"
      >
        <>
          {cartableTotalCount != 0 ? (
            cartable?.map((item: any, i: number) => (
              <div className="navi navi-spacer-x-0 ">
                {i === cartable.length ? (
                  <></>
                ) : (
                  <div className="navi-separator "></div>
                )}

                <Button
                  style={{ color: "#fff", fontSize: "12px", width: "100%" }}
                  className=" font-weight-bold colorFFF textFont11 "
                  onClick={() => handleClick(item)}
                >
                  <div
                    className="navi-footer  px-8 py-5"
                    style={{
                      marginRight: "10px",
                      alignItems: "normal",
                      width: "100%",
                    }}
                  >
                    <div style={{ float: "right" }}>{item.title}</div>

                    <div style={{ float: "left" }}>
                      <CustomBadge
                        sx={{ "&.MuiBadge-badge": { fontWeight: "bold" } }}
                        badgeContent={item?.count > 99 ? "+99" : item.count}
                        style={{ marginTop: "-22px", fontWeight: "bold" }}
                        className="summaryBadgeStyle"
                      />
                    </div>
                  </div>
                </Button>
              </div>
            ))
          ) : (
            <></>
          )}
        </>
      </Dropdown.Menu>
    </Dropdown>
  );
}

const TOKEN_KEY = "token";
const handelToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.setItem("setActivePage", "Wellcome");
};
